export const PRODUCTION_REGISTER_YARN_REPORT_REQUEST = 'PRODUCTION_REGISTER_YARN_REPORT_REQUEST';
export const PRODUCTION_REGISTER_YARN_REPORT_SUCCESS = 'PRODUCTION_REGISTER_YARN_REPORT_SUCCESS';
export const PRODUCTION_REGISTER_YARN_REPORT_FAILURE = 'PRODUCTION_REGISTER_YARN_REPORT_FAILURE';
export const PRODUCTION_REGISTER_YARN_FILTER_REPORT_REQUEST = 'PRODUCTION_REGISTER_YARN_FILTER_REPORT_REQUEST';
export const PRODUCTION_REGISTER_YARN_FILTER_REPORT_SUCCESS = 'PRODUCTION_REGISTER_YARN_FILTER_REPORT_SUCCESS';
export const PRODUCTION_REGISTER_YARN_FILTER_REPORT_FAILURE = 'PRODUCTION_REGISTER_YARN_FILTER_REPORT_FAILURE';
